import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "fixed lg:top-[72px] top-16 bg-white z-10 mb-6 shadow-[0_1px_0px_0px_rgba(0,0,0,0.08)] -mx-4 w-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-semibold" }, "Back", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-semibold" }, "Back to list", -1)
const _hoisted_4 = { class: "lg:mt-[72px] mt-14" }
const _hoisted_5 = { class: "flex md:flex-row flex-col relative" }
const _hoisted_6 = { class: "md:w-1/2 w-full md:border-r left_con border-neutral-100" }
const _hoisted_7 = { class: "flex items-center justify-between p-6 border-b border-neutral-100" }
const _hoisted_8 = { class: "px-2 py-[3px] text-xs font-bold text-white bg-primary-600 rounded-[20px]" }
const _hoisted_9 = { class: "h-[calc(100vh-200px)] overflow-auto" }
const _hoisted_10 = { class: "mt-6 flex justify-center" }
const _hoisted_11 = { class: "md:w-1/2 w-full right_con md:h-[calc(100vh-130px)]overflow-auto" }
const _hoisted_12 = {
  key: 0,
  class: "md:static absolute top-0 right-0 bg-white h-full overflow-auto"
}

import { ref, onMounted } from 'vue';
import UserLayout from '@/layouts/UserLayout.vue';
import ButtonComponent from '@/components/buttons/ButtonComponent.vue';

import NotificationCard from './Components/NotificationCard.vue';
import NotificationDetails from './Components/NotificationDetails.vue';

import Notifications from "@/classes/Notifications";

import SimplePagination from "@/components/partials/SimplePagination.vue";

import { filters, items } from "@/interfaces/pages/FilterPageInterface";

import assignValues from "@/helpers/assignValues"
import ArrowLeftIcon from "@/components/icons/arrowLeftIcon.vue";

import { useRouter } from 'vue-router';
import DateFormatter from "@/helpers/DateFormatter";


export default /*#__PURE__*/_defineComponent({
  __name: 'IndexPage',
  setup(__props) {

const router = useRouter();

const unreadNotif = ref<number>(0);
const showNotif = ref<string>('');
const setPage = ref(1);

const init = (): void => {
    Notifications.index({ page: setPage.value })
        .then(({ data }) => {
            console.log(data.item);
            filters.value = assignValues(filters.value, data);
            unreadNotif.value = data.unread;
            items.value = data.item;
        })
        .catch((error) => (console.log(error)))
}

const paginate = ({ page, rows }): void => {
    filters.value = Object.assign(filters.value, {
        page, rows
    })

    setPage.value = page;
    init();
};

const markAsRead = (notification: string, read_at: null | string): void => {
    
    showNotif.value = notification

    if (read_at == null || typeof read_at == 'undefined'){
        Notifications.markAsRead(notification)
            .then(() => (init()))
            .catch((error) => (console.log(error)))
    }
}


const markAllAsRead = (): void => {
    Notifications.markAllAsRead()
        .then(() => (init()))
        .catch((error) => (console.log(error)))
}

const renderShortDescription = (item: any) => {
    return item.data?.message || item.data?.contents?.content;
}

const renderLongDescription = (item: any) => {
    if (item.data?.message) {
        return `${item.data?.message} ${item.data?.html || ''}`;
    }
    return item.data?.contents?.content;
}

onMounted(() => {
    init()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (!showNotif.value)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).back()))
            }, [
              _createVNode(ButtonComponent, { customClass: "tertiary text-black hover:text-primary-600 transition py-4" }, {
                default: _withCtx(() => [
                  _createVNode(ArrowLeftIcon, { class: "object-contain w-6 h-6 mr-2" }),
                  _hoisted_2
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (showNotif.value)
          ? (_openBlock(), _createBlock(ButtonComponent, {
              key: 1,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (showNotif.value = '')),
              customClass: "tertiary text-black hover:text-primary-600 transition py-4"
            }, {
              default: _withCtx(() => [
                _createVNode(ArrowLeftIcon, { class: "object-contain w-6 h-6 mr-2" }),
                _hoisted_3
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("p", null, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(unreadNotif.value) + " Unread", 1)
              ]),
              (unreadNotif.value > 0)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "text-sm transition cursor-pointer text-neutral-900 hover:text-primary-600",
                    onClick: markAllAsRead
                  }, "Mark all as Read"))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items).data, (item) => {
                return (_openBlock(), _createBlock(NotificationCard, {
                  key: item,
                  title: item.data.subject,
                  date: _unref(DateFormatter).customDateFormat(item.created_at, 'yyyy-MM-dd hh:mm:ss'),
                  description: renderShortDescription(item),
                  notifNew: item.read_at,
                  onClick: ($event: any) => (markAsRead(item.id, item.read_at))
                }, null, 8, ["title", "date", "description", "notifNew", "onClick"]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(SimplePagination, {
                showRows: false,
                currentPage: _unref(items).current_page,
                "last-page": _unref(items).last_page,
                onUpdate: _cache[2] || (_cache[2] = (value) => paginate(value))
              }, null, 8, ["currentPage", "last-page"])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items).data, (item) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: item }, [
                (showNotif.value == item.id)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createVNode(NotificationDetails, {
                        title: item.data.subject,
                        date: item.data.updated_at,
                        description: renderLongDescription(item),
                        routeLink: item.data.properties.route,
                        buttonText: item.data.properties.button_name
                      }, null, 8, ["title", "date", "description", "routeLink", "buttonText"])
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})